
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.999 0c-8.836 0-16 7.164-16 16 0 8.837 7.164 16 16 16s16-7.163 16-16c0-8.836-7.164-16-16-16zm4.482 28.189c-.092-1.252-.195-2.803-.201-3.431-.04-.482-.092-1.708-1.256-2.491 4.621-.387 6.82-2.941 6.978-6.316.132-1.922-.632-3.612-1.989-4.976a27.326 27.326 0 00-.138-3.948c-1.042-.3-3.472.983-4.151 1.532-1.432-.556-4.937-.751-7.067 0-1.51-1.062-3.229-1.718-4.166-1.535-.865 1.917-.309 3.729-.14 3.945-1.114 1.018-2.668 2.271-2.246 4.896.677 3.849 3.385 5.925 7.745 6.433-.93.19-1.087.884-1.165 1.185-2.928 1.208-3.765-.746-4.135-1.255-1.229-1.521-2.332-1.08-2.4-1.056-.066.024-.116.12-.109.166.062.328.731.661.764.688.907.676 1.243 1.897 1.45 2.245 1.301 2.139 4.325 1.252 4.354 1.27.002.187-.021 1.761-.039 2.986C7.056 27.021 2.999 21.991 2.999 16c0-7.18 5.82-13 13-13s13 5.82 13 13c0 5.603-3.55 10.362-8.518 12.189z","fill":"#2B414D"}})])
          )
        }
      }
    